import { render, staticRenderFns } from "./BlogArticle.vue?vue&type=template&id=4fcd5e51&lang=pug&"
import script from "./BlogArticle.vue?vue&type=script&lang=js&"
export * from "./BlogArticle.vue?vue&type=script&lang=js&"
import style0 from "./BlogArticle.vue?vue&type=style&index=0&id=4fcd5e51&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports